/**
 * Created by MINH on 9/28/2017.
 */

class NotifyClass {

    static info(msg) {
        $.toast({
            text: msg,
            showHideTransition: 'slide',
            icon: 'info',
            loaderBg: '#57c7d4',
            position: 'top-center'
        })
    }

    static success(msg) {
        $.toast({
            text: msg,
            showHideTransition: 'slide',
            icon: 'success',
            loaderBg: '#46c35f',
            position: 'top-center'
        })
    }

    static error(msg) {
        $.toast({
            text: msg,
            showHideTransition: 'slide',
            icon: 'error',
            loaderBg: '#f96868',
            position: 'top-center'
        })
    }

    static warning(msg) {
        $.toast({
            text: msg,
            showHideTransition: 'slide',
            icon: 'warning',
            loaderBg: '#f2a654',
            position: 'top-center'
        })
    }

    static ajax(response) {
        switch (response.code){
            case 1:
                this.success(response.msg);
                break;
            case 0:
                this.warning(response.msg);
                break;
            default:
                this.error(response.msg);
        }
    }

}


window.NotifyClass = NotifyClass;




